import { useEffect } from 'react';
import { getUserSession } from '../../../../util/core/Session';
import './styles.css';

function PreLoader() {
  const userSession = getUserSession();
  const screenConfig = userSession?.screenConfig;
  const defaultLogo = '/image/rsholding-isotipo.png';

  useEffect(() => {
    if (screenConfig?.favicon_img) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = screenConfig?.favicon_img;
    }
    if (screenConfig?.title) {
      document.title = screenConfig.title
    }
  }, []);


  return (
    <div className="preloader flex-column justify-content-center align-items-center">
      <img className="animation__shake" src={screenConfig?.isotype_img || defaultLogo} alt="AdminLTELogo" width="60" />
    </div>
  );
}

export default PreLoader;
